import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { action, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import { Processo } from '../modelo';
import ImportacaoService from '../services/ImportacaoService';
import ImportacaoProcessosStore from '../store/ImportacaoProcessosStore';
import BotaoAbrirProcessoPJe from './BotaoAbrirProcessoPJe';
import EspelhoProcesso from './EspelhoProcesso';
import PainelExpandidoImportacao from './PainelExpandidoImportacao';
import LabelNumeroProcessoCompleto from './escaninho/LabelNumeroProcessoCompleto';
import SistemaDeOrigem from './escaninho/SistemaDeOrigem';

interface IPropsAccordionProcessoImportacao {
    processo: Processo;
    onSelect?: () => void;
}


class AccordionProcessoImportacao extends React.Component<IPropsAccordionProcessoImportacao> {
    handleChangePainelExpandido = () => {
        if (!ImportacaoProcessosStore.idProcessoPainelExpandido || ImportacaoProcessosStore.idProcessoPainelExpandido !== this.idProcesso) {
            ImportacaoProcessosStore.idProcessoPainelExpandido = this.idProcesso;
            ImportacaoService.consultarDadosProcesso(this.props.processo);
        } else {
            ImportacaoProcessosStore.idProcessoPainelExpandido = undefined;
        }
    };

    selecionarProcesso = () => {
        this.props.processo.selecionar(!this.props.processo.selecionado);
        this.props.onSelect && this.props.onSelect();
    };

    handleStopPropagation = (e: React.MouseEvent) => {
        e.stopPropagation();
    }

    constructor(props: IPropsAccordionProcessoImportacao) {
        super(props);

        makeObservable(this, {
            handleChangePainelExpandido: action,
            selecionarProcesso: action,
});
    }

    get idProcesso() {
        return this.props.processo.identificadorProcesso;
    }

    render() {
        return (
            <Accordion expanded={ImportacaoProcessosStore.idProcessoPainelExpandido === this.idProcesso}
                onChange={this.handleChangePainelExpandido}
            >
                <AccordionSummary
                    id="panel1a-header"
                    aria-controls="panel1a-content"
                >
                    <div className="sumario-processo-importacao">
                        <div className='divFlexRow aCenter'>
                            <Checkbox onChange={this.selecionarProcesso}
                                onClick={this.handleStopPropagation}
                                checked={this.props.processo.selecionado}
                                value={this.props.processo.selecionado}
                                color="primary" />
                            <Typography>
                                <LabelNumeroProcessoCompleto processo={this.props.processo} />
                            </Typography>
                            <div className='divFlexRow items-sumario aCenter' onClick={this.handleStopPropagation} >
                                <EspelhoProcesso idProcesso={this.idProcesso} botaoAbrirEspelho />
                                <div className='divFlexRow items-sumario aCenter' style={{cursor:'default'}} >
                                    {this.props.processo.ehPje &&
                                        <BotaoAbrirProcessoPJe  idProcesso={this.idProcesso} />
                                    }
                                    {this.props.processo.ehLegado &&
                                        <SistemaDeOrigem processo={this.props.processo} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <PainelExpandidoImportacao processo={this.props.processo} />
                </AccordionDetails>
            </Accordion>
        );
    }
}

export default observer(AccordionProcessoImportacao);
